import { api } from './http/coreClient';
import { LoginRequest, LoginResponse } from 'types/auth.types';

export const authAPI = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await api.post<LoginResponse>('/login', credentials);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.detail || 'Login failed');
    }
  },

  logout: async (userId: string): Promise<void> => {
    try {
      await api.post('/logout', { user_id: userId });
    } catch (error) {
      console.error('Logout error:', error);
    }
  },
};
